export default __webpack_public_path__ + "static/20250829-228ca709916088a411f63cf57b58e839.png";